import React from 'react';
import { Calendar } from 'lucide-react';
import { Badge } from './ui/badge';

const EventPhotosGallery = () => {
  const eventPhotos = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/ix6mwyp9_AA.jpg',
    title: 'Opening Ceremony 2025',
    edition: '1st Edition',
    year: '2025'
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/99deuy72_AAA.jpg',
    title: 'Festival Audience',
    edition: '1st Edition',
    year: '2025'
  },
  {
    id: 3,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/uxk60bky_AAAAAAAA.jpg',
    title: 'Panel Discussion',
    edition: '1st Edition',
    year: '2025'
  },
  {
    id: 4,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/uuh3uk77_623455942_17911356264293745_1925311107839809833_n.jpg',
    title: 'Honoring Guests',
    edition: '2nd Edition',
    year: '2026'
  },
  {
    id: 5,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/pnngc5td_622980218_17911098411293745_7174875235744196330_n.jpg',
    title: 'International Delegates',
    edition: '2nd Edition',
    year: '2026'
  },
  {
    id: 6,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/hkdvlg21_622967134_17911052643293745_4692255836037412985_n.jpg',
    title: 'Award Winner',
    edition: '2nd Edition',
    year: '2026'
  },
  {
    id: 7,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/oyqvyo5k_622816454_17911096770293745_5235378013573829947_n.jpg',
    title: 'Audience Engagement',
    edition: '2nd Edition',
    year: '2026'
  },
  {
    id: 8,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/yuii44nz_AAAAA.webp',
    title: 'Award Ceremony 2025',
    edition: '1st Edition',
    year: '2025'
  },
  {
    id: 9,
    image: 'https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/zah5v4k3_621521752_17911098399293745_181826102507419445_n.jpg',
    title: 'Cinema Beyond Borders',
    edition: '2nd Edition',
    year: '2026'
  }];


  return (
    <section id="gallery" className="bg-black text-white py-16 sm:py-24 md:py-32">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Section Title */}
        <div className="mb-12 sm:mb-14 md:mb-16 text-center">
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-4 sm:mb-6">
            FESTIVAL <span className="font-light">GALLERY</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-400">
            Moments from our previous editions
          </p>
        </div>

        {/* Photos Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
          {eventPhotos.map((photo, index) =>
          <div
            key={photo.id}
            className="group relative aspect-[4/3] overflow-hidden rounded-lg bg-zinc-900 cursor-pointer"
            style={{
              animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
            }}>

              <img
              src={photo.image}
              alt={photo.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />


              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 md:p-6">
                  <div className="flex items-center gap-2 mb-2 sm:mb-3">
                    <Badge className="bg-red-500 text-white border-0 text-xs sm:text-sm">
                      {photo.edition}
                    </Badge>
                    <Badge variant="secondary" className="bg-white/10 text-white border-white/20 text-xs sm:text-sm">
                      {photo.year}
                    </Badge>
                  </div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold line-clamp-2">{photo.title}</h3>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>);

};

export default EventPhotosGallery;